module.exports = require("@mui/material/Typography");